import React from "react";
import { Modal, Button, Form, InputGroup } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { API_ENDPOINTS } from "../../constant/_constant";
import { toast } from "react-toastify";
import usePostRequest from "../../hooks/usePostRequest";

function Generate_Email({ show, onClose }) {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
  } = useForm();

  const { postData: sendEmail, isLoading } = usePostRequest(API_ENDPOINTS.GENERATE_REGISTER_LINK);

  const onSubmit = (data) => {
    const payload = {
      email: data.email,
    };

    sendEmail(payload, onSuccess, onError);
  };

  const onSuccess = () => {
    toast.success("Email sent successfully!");
    reset();
    onClose();
  };

  const onError = (error) => {
    toast.error(error?.message || "Something went wrong.");
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Send Email</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body>
          <Form.Group>
            <Form.Label className="required">Email Address</Form.Label>
            <InputGroup>
              <Form.Control
                type="email"
                placeholder="Enter email"
                {...register("email", {
                  required: "Email is required",
                  pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: "Invalid email format",
                  },
                })}
              />
            </InputGroup>
            {errors.email && (
              <span className="text-danger">{errors.email.message}</span>
            )}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button type="submit" variant="warning" disabled={isSubmitting || isLoading}>
            {isSubmitting || isLoading ? "Sending..." : "Send Email"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default Generate_Email;
